import React from "react";

const ContactAreaThree = () => {
  return (
    <>
      {/* ========================= contact Area Three start =========================*/}
      <div className='price-process-area pd-top-120' id="why-choose">
        <div className='contact-inner-1 contact-inner-2'>
          <div className='row'>
            <div
              className='col-lg-6 '
              data-aos='fade-right'
              data-aos-delay='200'
              data-aos-duration='1500'
            >
              <img className='w-100' src='assets/img/about/12.png' alt='img' />
            </div>
            <div
              className='col-lg-4'
              data-aos='fade-left'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='section-title mb-0'>
                <h6 className='sub-title'>GET STARTED NOW</h6>
                <h2 className='title mb-4'>
                Why Choose  <span>Aasaann?</span>
                </h2>
                <div className='media mb-3'>
                  <div className='media-left me-3'>
                    <img src='assets/img/icon/26.svg' alt='img' />
                  </div>
                  <div className='media-body'>
                    <h5>Ease of Use </h5>
                    <p className='mb-0'>
                    Designed with brokers in mind, Aasaann offers a simple, intuitive interface that saves time and effort.
                    </p>
                  </div>
                </div>
                <div className='media mb-3'>
                  <div className='media-left me-3'>
                    <img src='assets/img/icon/26.svg' alt='img' />
                  </div>
                  <div className='media-body'>
                    <h5>Comprehensive</h5>
                    <p className='mb-0'>
                    From transactions to reports, everything needed to manage a vegetable market business is in one place.
                    </p>
                  </div>
                </div>
                <div className='media mb-3'>
                  <div className='media-left me-3'>
                    <img src='assets/img/icon/26.svg' alt='img' />
                  </div>
                  <div className='media-body'>
                    <h5>Real-Time Data</h5>
                    <p className='mb-0'>
                    Access real-time information for quick decision-making and staying on top of the business.
                    </p>
                  </div>
                </div>
                <div className='media'>
                  <div className='media-left me-3'>
                    <img src='assets/img/icon/26.svg' alt='img' />
                  </div>
                  <div className='media-body'>
                    <h5>Efficient</h5>
                    <p className='mb-0'>
                    Automate processes, reduce errors, and increase profitability by eliminating manual record-keeping.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*========================= contact-inner Three end =========================*/}
    </>
  );
};

export default ContactAreaThree;
